"use client";

import Image from 'next/image';
import { useTheme } from 'next-themes';

export default function HeroSection() {
    const { theme } = useTheme();

    return (
        <section className="relative overflow-hidden">
            <div className="w-full max-w-full relative">
                {/* Background image that changes based on theme */}
                <Image
                    src={theme === 'dark' ? '/cover-bg-dark.jpg' : '/cover-bg-light.jpg'}
                    alt="Background"
                    width={1200}
                    height={800}
                    className="w-full h-auto object-cover absolute inset-0 z-0"
                    priority
                />

                {/* Main cover image */}
                <Image
                    src="/cover-fabian.png"
                    alt="5 Herramientas de IA que revolucionarán el Marketing político"
                    width={1200}
                    height={800}
                    className="w-full h-auto object-contain max-w-full relative z-10"
                    priority
                />
            </div>
        </section>
    );
}
